import React from 'react';
import PropTypes from 'prop-types'
import { Row } from 'react-bootstrap';
const find = require('lodash/find');
const forEach = require('lodash/forEach');
const uuid = require('uuid');
const md5 = require('md5-jkmyers'); // claims to be the fastest
import { withRouter } from 'react-router-dom'
const Moment = require('moment');

const Globals = require('../../../app/globals');
const GroupActions = require('../actions/GroupActions');
const GroupStore = require('../stores/GroupStore');
import Navigator from '../Navigator';
import MainNav from './DashboardNew/Menu/MainNav';
import SubNav from './nav/SubNav';
import BackButton from './nav/BackButton';
import SideNav from './nav/SideNav';
import SortableTableClassic from './table/SortableTableClassic';
import ConfirmModal from './modal/ConfirmModal';
import SingleInputModal from './modal/SingleInputModal2';

const propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            group_id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

const defaultProps = {};

class GroupView extends React.Component {
    constructor(props) {
        super(props);
        const groupStoreState =  GroupStore.getState();
        let group = null;
        let students = [];
        if (groupStoreState) {
            if (groupStoreState.groups) {
                group = find(groupStoreState.groups, { id: props.match.params.group_id });
            }

            if (groupStoreState.group_users) {
                students = groupStoreState.group_users[props.match.params.group_id] || [];
            }

        }

        this.state = {
            group: group || null,
            students: students,
            groupStoreState: groupStoreState,
            modalState: {
                renameGroup: false,
                inviteStudent: false,
                removeStudent: false
            },
            removeHash: "",
            renameGroupActionId: null,
            inviteStudentActionId: null,
            removeStudentActionId: null,

            // these two values are a workaround for SortableTable not re-rendering when it gets new data
            currentStudentTableHash: '',
            renderedStudentTableHash: '',
        };

        this.backHandler = this.backHandler.bind(this);
        this.renameGroupHandler = this.renameGroupHandler.bind(this);
        this.inviteStudentHandler = this.inviteStudentHandler.bind(this);
        this.studentClickHandler = this.studentClickHandler.bind(this);
        this.onStudentRemoveClick = this.onStudentRemoveClick.bind(this);
        this.handleRemoveStudent = this.handleRemoveStudent.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.unsubscribes = [
            GroupStore.listen(this.onGroupStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        GroupActions.getGroups(uuid.v4());
        GroupActions.getGroupUsers(uuid.v4(), { id: this.props.match.params.group_id });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onGroupStoreChange(state) {
        let group = this.state.group;
        let students = [];
        let studentTableHash = '';
        let additionalState = {};
        const groupStoreState =  GroupStore.getState();
        if (groupStoreState) {
            if (groupStoreState.groups) {
                group = find(groupStoreState.groups, { id: this.props.match.params.group_id });
            }
            if (groupStoreState.group_users) {
                students = groupStoreState.group_users[this.props.match.params.group_id] || [];
                let displayDataToHash = [];
                forEach(students, (student) => {
                    displayDataToHash.push(student.id);
                    displayDataToHash.push(student.email);
                    displayDataToHash.push(student.display_name);
                    displayDataToHash.push(student.group_status_display_name);
                    displayDataToHash.push(',');
                });
                studentTableHash = md5(displayDataToHash.join('|'));
            }
        }

        if (state.action.id === this.state.renameGroupActionId) {
            if (!state.action.error) {
                additionalState = { ...additionalState, modalState: { ...this.state.modalState, renameGroup: false } };
            }
        }
        if (state.action.id === this.state.inviteStudentActionId) {
            if (!state.action.error) {
                additionalState = { ...additionalState, modalState: { ...this.state.modalState, inviteStudent: false } };
            }
        }
        if (state.action.id === this.state.removeStudentActionId) {
            additionalState = { ...additionalState, removeStudentActionId: null };
            if (!state.action.error) {
                additionalState = { ...additionalState, modalState: { ...this.state.modalState, removeStudent: false } };
            }
        }

        this.setState({
            groupStoreState: state,
            group: group,
            students: students,
            currentStudentTableHash: studentTableHash,
            ...additionalState,
        });

        // if (studentTableHash !== this.state.renderedStudentTableHash) {
        //     const self = this;
        //     window.setTimeout(function() {
        //         // console.log("setting renderedStudentTableHash to " + studentTableHash);
        //         self.setState({ renderedStudentTableHash: studentTableHash });
        //     }, 1000);
        // }
    }

    backHandler() {
        Navigator.goToDashboardAuthor(this.props.history);
        //Navigator.goToDashboardAuthorAuthoringView(this.props.history, Globals.view_tokens.author_dash.GROUPS);
    }

    renameGroupHandler(newName) {
        const renameGroupActionId = uuid.v4();
        this.setState({ renameGroupActionId: renameGroupActionId}, () => {
            GroupActions.renameGroup(renameGroupActionId, { id: this.props.match.params.group_id, name: newName });
        });
    }

    inviteStudentHandler(email_address) {
        const inviteStudentActionId = uuid.v4();
        this.setState({ inviteStudentActionId: inviteStudentActionId }, () => {
            GroupActions.inviteGroupUser(inviteStudentActionId, { group_id: this.props.match.params.group_id, email: email_address });
        });
    }

    studentClickHandler(e, id) {
        return;
    }

    onStudentRemoveClick(studentHash) {
        this.setState({
            removeHash: studentHash,
            modalState: {
                ...this.state.modalState,
                removeStudent: true,
            }
        });
    }

    handleRemoveStudent() {
        const removeStudentActionId = uuid.v4();
        this.setState({ removeStudentActionId: removeStudentActionId }, () => {
            GroupActions.removeGroupUser(removeStudentActionId, { group_id: this.props.match.params.group_id, user_hash: this.state.removeHash });
        });
    }

    showModal(modalName) {
        this.setState({ modalState: { ...this.state.modalState, [modalName]: true } });
    }

    hideModal(modalName) {
        this.setState({ modalState: { ...this.state.modalState, [modalName]: false } });
    }

    render() {
        let actions, groupName;
        if (this.state.group) {
            groupName = this.state.group.name;
            actions = [
                {
                    value: "rename group",
                    handler: this.showModal.bind(this, "renameGroup"),
                    group: 0,
                    bgColor: "#cccccc",
                    icon: `${GlobalConfig.StaticUrl}/img/EditAction_sm.svg`,
                    iconStyle: { width: '24px' },
                    subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                },
                {
                    value: "invite student",
                    handler: this.showModal.bind(this, "inviteStudent"),
                    group: 0,
                    bgColor: "#DCEDC2",
                    icon: `${GlobalConfig.StaticUrl}/img/AddAction_sm.svg`,
                    iconStyle: { width: '24px' },
                    subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                },
            ];
        }
        else {
            if (this.state.groupStoreState && this.state.groupStoreState.loading) {
                groupName = "Loading...";
            }
            else {
                groupName = "ERROR"; // What is our state?
                if (GlobalConfig.DevMode) {
                    console.log("Unknown state for rendering.  state:" +  JSON.stringify(this.state));
                }
            }

            actions = [];
        }

        const self = this;
        let studentTable = null;

        if (this.state.students && this.state.students.length > 0) {
            // console.log("rendering table where currentStudentTableHash = " + this.state.currentStudentTableHash);
            // fields: id, display_name, email, group_status, group_status_display_name
            const tableColumns = [
                {displayName: 'Name',           key: 'display_name',                size: 50, type: 'string' },
                {displayName: 'Email',          key: 'email',                       size: 50, type: 'string' },
                {displayName: 'Status',         key: 'group_status_display_name',   size: 50, type: 'string' }, // The column size values correspond to 'flexGrow' which is kind of a black box
                {displayName: ' ',              key: 'deleteButton',                size: 10, type: 'iconButton' }
            ];

            // var mismatch = (this.state.currentStudentTableHash !== this.state.renderedStudentTableHash); // TODO: how to get table to update after we send an invite
            const tableRows = this.state.students.map((student) => {
                return {
                    key: student.id,
                    email: student.email,
                    display_name: student.display_name || '',
                    group_status_display_name: student.group_status_display_name,
                    deleteButton: {
                        className: 'assignment-delete-button fa fa-trash',
                        onClick: this.onStudentRemoveClick.bind(this, student.hash),
                    }
                };
            });
            studentTable = (
                <div className="group-students-table margin-top-lg">
                    <SortableTableClassic
                        key="t-group-students"
                        title="Students"
                        onRowClick={this.studentClickHandler}
                        rows={tableRows}
                        uniqueRowKey="hash"
                        selectedRowKey={this.state.studentSelectedRowKey}
                        columns={tableColumns}
                    />
                </div>
            );
        }

        return (
            <div>
                <MainNav onClickBrandLogo={Navigator.goToDashboardAuthor.bind(this, this.props.history)} />
                <div className="container main-container">
                    <SubNav
                        menuClasses= "d-inline-block d-sm-none"
                        actions={actions}
                    >
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {groupName}
                            </div>
                        </div>
                    </SubNav>
                    <Row className="main-content-nav">
                        <div className="col-12 col-sm-9 main-content">
                            {studentTable}
                        </div>
                        <SideNav className="d-none d-sm-block col-sm-3 mzl-cs-secondary-button-group" actions={actions} />
                    </Row>
                </div>
                {this.state.modalState["renameGroup"] &&
                    <SingleInputModal
                        show
                        action={this.state.groupStoreState ? this.state.groupStoreState.action : {}}
                        childActionID={this.state.renameGroupActionId}
                        headerText="Rename Group"
                        inputLabel="new name"
                        ariaLabel="new name"
                        buttonText="confirm"
                        defaultValue={groupName}
                        closeHandler={this.hideModal.bind(this, "renameGroup")}
                        submitHandler={this.renameGroupHandler}
                    />
                }
                {this.state.modalState["inviteStudent"] &&
                    <SingleInputModal
                        show
                        action={this.state.groupStoreState ? this.state.groupStoreState.action : {}}
                        childActionID={this.state.inviteStudentActionId}
                        headerText="Invite Student"
                        inputLabel="email address"
                        ariaLabel="email address"
                        buttonText="confirm"
                        defaultValue={''}
                        closeHandler={this.hideModal.bind(this, "inviteStudent")}
                        submitHandler={this.inviteStudentHandler}
                    />
                }
                {this.state.modalState["removeStudent"] &&
                    <ConfirmModal
                        show
                        modalTitle="Remove Student"
                        text="Are you sure you want to remove this student from the group?"
                        buttonText="remove"
                        closeHandler={this.hideModal.bind(this, "removeStudent")}
                        confirmHandler={this.handleRemoveStudent}
                    />
                }
            </div>
        );
    }
}

GroupView.propTypes = propTypes;
GroupView.defaultProps = defaultProps;

export default withRouter(GroupView);